import http from "../http";
import api from "../../config/api";
import {  MedicalDataResponse, NewsDetailsResponse, NewsResponse } from "../../interfaces/api/congresses";

/**
 * Reports API service
 */
const tabs = {
  /**
   * Get forms
   * @returns {Promise<FormsResponse>} API response
   */
  getFilters: (): Promise<MedicalDataResponse> =>
    http.get(api.filters),
  
  /**
   * Get news
   * @param {Object} params - Query parameters
   * @param {number} params.pageSize - Number of items per page
   * @param {number} params.page - Page number
   * @param {number} params.tab_id - Tab ID
   * @param {number} [params.specialty_id] - Specialty ID
   * @param {number} [params.subspecialty_id] - Subspecialty ID
   * @param {number} [params.type_of_study_id] - Type of study ID
   * @returns {Promise<NewsResponse>} API response
   */
  getNews: (params: {
    pageSize: number;
    page: number;
    tab_id: number;
    specialty_id?: number;
    subspecialty_id?: number;
    type_of_study_id?: number;
  }): Promise<NewsResponse> =>
    http.get(api.news, { ...params }),

  /**
   * Get news details by ID
   * @param {number} id - News ID
   * @returns {Promise<NewsResponse>} API response
   */
  getNewsDetails: (id: number): Promise<NewsDetailsResponse> => http.get( `${api.news}/${id}`),
};

export default tabs;